<template>
  <h3 class="pb5">Facturation SOQUIJ (CDX 0243)</h3>
  <CritereRechercheHabilitationSecuritaire ref="critereRechercheHabilitationSecuritaire"/>
  <ButtonBar @fermer="fermer" @imprimer="imprimer"/>
</template>

<script>
import CritereRechercheHabilitationSecuritaire
  from "@/components/rapports/Rechercher/CritereRechercheHabilitationSecuritaire.vue";
import ButtonBar from "@/components/rapports/Rechercher/ButtonBar.vue";
import axios from "axios";
import {mapGetters} from "vuex";

export default {
  name: "FacturationSOQUIJ",
  components: {ButtonBar, CritereRechercheHabilitationSecuritaire},

  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Habilitation sécuritaire");
  },

  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  methods: {
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    imprimer() {
      this.$root.$refs.breadcrumbComp.activeBallBeat = true;
      var criteresRapportVO = this.$refs.critereRechercheHabilitationSecuritaire.getCritereRecherche();
      criteresRapportVO.titre = "FacturationSOQUIJ";
      criteresRapportVO.nomRapport = "dossier.FacturationSOQUIJGenerateurRapport_CDX_0243";
      this.$store.dispatch("rapports/obtenirRapportAction",
          criteresRapportVO
      )
          .then(() => {
            this.$root.$refs.breadcrumbComp.activeBallBeat = false;
          });
    }
  },
}
</script>